module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Lounge_D4_cam4.32a08624.jpg";